



















	import Vue from 'vue';
    import EinladungComp from "./EinladungComp.vue";
    import _raids from '../../services/endpoints/raids';
	import { playerInvite } from 'models/Types';

    export default Vue.extend({
        name: "EinladungenComp",
        components: {EinladungComp},
        data: () => ({
            invites: [] as playerInvite[],
        }),
        methods: {
            accept: async function(raidId: number): Promise<void> {
                this.invites = this.invites.filter(r => r.id !== raidId);
                await _raids.acceptInvite(raidId);
            },
            decline: async function(raidId: number): Promise<void> {
                this.invites = this.invites.filter(r => r.id !== raidId);
                await _raids.deleteInviteAsSelf(raidId);
            },
        },
        created: async function(): Promise<void> {
            this.invites = await _raids.pendingInvitesForPlayer();
        }
    })
